import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OpnOfferEvaluationMethodSaveModel } from '.';

const localApiUrl = `${environment.apiUrl}/RequestOpnOfferEvaluationMethods`;

@Injectable()
export class OpnOfferEvaluationMethodsService {

  constructor(private http: HttpClient) { }

  delete(id: number): Promise<void> {
      return this.http.delete<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: OpnOfferEvaluationMethodSaveModel): Promise<void> {
      return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
